import * as React from 'react';
import { Dayjs } from 'dayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';

type FieldComponentProps = React.ComponentProps<typeof SingleInputDateRangeField>;
type FieldComponent = React.ForwardRefExoticComponent<
  FieldComponentProps & React.RefAttributes<HTMLInputElement>
> & { fieldType?: string };

const WrappedSingleInputDateRangeField = React.forwardRef<HTMLInputElement, FieldComponentProps>(
  (props, ref) => {
    return (
      <SingleInputDateRangeField
        size="medium"
        {...props}
        ref={ref}
        sx={{
          '.MuiInputBase-root': { fontSize: '14px' },
        }}
      />
    );
  }
) as FieldComponent;

WrappedSingleInputDateRangeField.fieldType = 'single-input';

type SingleInputDateRangePickerProps = {
  label: string;
  name: string;
  value?: [Dayjs | null, Dayjs | null] | string;
  //TODO: TIPAR ESE ANY
  onChange: (value: [Dayjs | null, Dayjs | null] | string) => void;
};

//TODO: esto se está exportando por defecto, no debería ser así probablemente
export default function SingleInputDateRangePicker(props: SingleInputDateRangePickerProps) {
  const { label, name, value, onChange } = props;

  return (
    <DateRangePicker
      value={value as [Dayjs, Dayjs]}
      onChange={onChange}
      slots={{ field: WrappedSingleInputDateRangeField }}
      label={label}
      name={name}
      sx={{
        fontSize: '10px',
      }}
    />
  );
}
